// ============================================================================
// SYSTELOS - PageContainer Component
// ============================================================================
// Container padrão para páginas com max-width centralizado
// Versão: 1.0 | Criado: 29/12/2025
// ============================================================================

import { ReactNode } from 'react';

// ============================================================================
// TYPES
// ============================================================================

interface PageContainerProps {
  children: ReactNode;
  /** Largura máxima do container (default: 1400px) */
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full';
  /** Padding horizontal customizado */
  padding?: 'none' | 'sm' | 'md' | 'lg';
  /** Classes CSS adicionais */
  className?: string;
}

// ============================================================================
// CONSTANTS
// ============================================================================

const MAX_WIDTH_CLASSES: Record<string, string> = {
  sm: 'max-w-[900px]',
  md: 'max-w-[1100px]',
  lg: 'max-w-[1400px]',
  xl: 'max-w-[1600px]',
  '2xl': 'max-w-[1800px]',
  full: 'max-w-full',
};

const PADDING_CLASSES: Record<string, string> = {
  none: 'px-0',
  sm: 'px-2 md:px-4',
  md: 'px-4 md:px-6',
  lg: 'px-6 md:px-8',
};

// ============================================================================
// COMPONENT
// ============================================================================

export function PageContainer({
  children,
  maxWidth = 'lg',
  padding = 'md',
  className = '',
}: PageContainerProps) {
  const maxWidthClass = MAX_WIDTH_CLASSES[maxWidth];
  const paddingClass = PADDING_CLASSES[padding];

  return (
    <div 
      className={`
        ${maxWidthClass}
        mx-auto
        ${paddingClass}
        py-6
        ${className}
      `.trim().replace(/\s+/g, ' ')}
    >
      {children}
    </div>
  );
}

export default PageContainer;

